import './assets/scss/style.scss'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import iosScrollbar from '@/directives/iosScrollbar';
import WebApp from '@twa-dev/sdk';

import App from './App.vue'
import router from './router'

WebApp.ready();

const app = createApp(App)

app.use(createPinia())
 app.directive('ios-scrollbar', iosScrollbar);
app.use(router)
  

app.mount('#app')


